import dynamic from 'next/dynamic';
import { UserBasicInfoProps } from './UserBasicInfo.types';
import { UserBasicInfoV2Props } from './V2/index.types';

export const UserBasicInfo = dynamic<UserBasicInfoProps>(() => import('./UserBasicInfo'));

export const UserBasicInfoV2 = dynamic<UserBasicInfoV2Props>(() =>
  import('./V2').then(module => module.UserBasicInfoV2)
);
